import { useGetCourseQuery } from "@api/course";
import LoadingSpinner from "@components/LoadingSpinner";
import { useIsUserRole, useUserData } from "@hooks/auth";
import { JSX } from "react";
import { Navigate, useParams } from "react-router";

export const RequireLecturer = ({
  children,
}: { children: JSX.Element }): JSX.Element => {
  if (!useIsUserRole("lecturer", "admin")) {
    return <Navigate to="/" replace />;
  }
  return children;
};
export const RequireAdmin = ({
  children,
}: { children: JSX.Element }): JSX.Element => {
  if (!useIsUserRole("admin")) {
    return <Navigate to="/" replace />;
  }
  return children;
};
export const RequireManager = ({
  children,
}: { children: JSX.Element }): JSX.Element => {
  const { user } = useUserData();
  const { courseId } = useParams();

  if (!user || !courseId) {
    return <Navigate to="/" replace />;
  }

  const { data: course, isLoading } = useGetCourseQuery(courseId);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  const isManaging = course?.isManaging || user.role === "admin";

  if (!isManaging) {
    return <Navigate to="/" replace />;
  }
  return children;
};
